export default {
  title: "Credits",
  caption: "Manage credit balances and meters",
  plans: {
    menuTitle: "Plans",
    title: "Subscription plans",
    subtitle:
      "The plan catalog. Code-seeded (system) plans are read-only except for the active toggle; add custom plans below.",
    newPlan: "New plan",
    newTitle: "New plan",
    editTitle: "Edit plan",
    empty: "No plans yet.",
    plan: "Plan",
    product: "Product",
    key: "Key",
    displayName: "Name",
    tier: "Tier",
    price: "Price",
    priceCents: "Price (cents)",
    currency: "Currency",
    entitlements: "Entitlements",
    entitlementsHint: "Key → limit. Use -1 for unlimited. E.g. lms.max_courses → 50.",
    addEntitlement: "Add entitlement",
    isDefault: "Default plan",
    isActive: "Active",
    default: "Default",
    system: "System",
    save: "Save",
    saved: "Plan saved",
    cancel: "Cancel",
  },
  balances: {
    title: "Credit Balances",
    home: { title: "Balances" },
    set: "Set Balance",
    new: "Grant Credits",
    fields: {
      meter: "Meter",
      subject: "Subject",
      user: "User",
      tenant: "Tenant",
      balance: "Balance",
      unlimited: "Unlimited",
      userId: "User ID",
    },
    placeholder: {
      noBalances: "No wallets yet — set a balance to start gating.",
    },
    actions: {
      save: "Save",
      cancel: "Cancel",
    },
  },
  transactions: {
    title: "Credit Transactions",
    fields: {
      meter: "Meter",
      subject: "Subject",
      user: "User",
      delta: "Delta",
      balanceAfter: "Balance after",
      reason: "Reason",
      ref: "Reference",
      createdAt: "When",
      actor: "Actor",
    },
    placeholder: {
      empty: "No transactions yet.",
    },
  },
  meters: {
    title: "Meters",
    fields: {
      key: "Key",
      displayName: "Display name",
      description: "Description",
    },
  },
  badge: {
    label: "Credits",
    unlimited: "∞",
    none: "0",
  },
  errors: {
    insufficient: {
      title: "Insufficient credits",
      description:
        "You're out of credits for {meter}. Ask an administrator to grant more credits.",
    },
    planLimit: {
      title: "Plan limit reached",
      description:
        "You've reached your plan's limit. Upgrade your plan to add more, or ask an administrator.",
    },
  },
  upgrade: {
    title: "Upgrade your plan",
    subtitle: "You've reached the limit of the {plan} plan.",
    switchTo: "Switch to {plan}",
    switched: "Switched to {plan}",
    pay: "Upgrade to {plan}",
    checkoutStarted: "Redirecting to checkout…",
    notNow: "Not now",
    close: "Close",
    maxedOut: "You're on the highest plan. Contact us if you need more.",
  },
  subscriptionReturn: {
    successTitle: "You're upgraded 🎉",
    successBody: "Your new plan is active. Higher limits apply right away.",
    backToStudio: "Back to studio",
  },
  buy: {
    menuTitle: "Buy credits",
    title: "Buy credits",
    subtitle:
      "Pick a pack — you'll be redirected to our payment provider to complete checkout.",
    creditsLabel: "credits",
    buyButton: "Buy now",
    noPacks: "No packs are currently available. Check back later.",
  },
  return: {
    confirming: "Confirming your payment…",
    slowTitle: "We've got your payment",
    slowBody:
      "This is taking a little longer than usual. You can close this page — we'll email you the moment your credits land.",
    backToCredits: "Back to credits",
    successTitle: "Credits added",
    viewHistory: "View history",
    failureTitle: "Payment didn't complete",
    tryAgain: "Try again",
    missingIdTitle: "Missing topup reference",
  },
  myTopups: {
    menuTitle: "My purchases",
    title: "My credit purchases",
    buyMore: "Buy more credits",
    empty: "No purchases yet.",
  },
  adminTopups: {
    menuTitle: "Top-ups",
    title: "All top-ups",
    userFilter: "User ID",
    statusFilter: "Status",
    statusAll: "All",
    empty: "No top-ups in this tenant.",
  },
  topups: {
    fields: {
      createdAt: "When",
      pack: "Pack",
      user: "User",
      amount: "Amount",
      credits: "Credits",
      status: "Status",
      actions: "Actions",
    },
  },
  refund: {
    title: "Refund top-up",
    description:
      "Original purchase: {amount}. Refund will revoke the matching credit amount from the user's wallet.",
    amountLabel: "Refund amount",
    amountPlaceholder: "Leave empty for full refund",
    amountHelp:
      "Amount in the same currency as the original purchase. Leave blank to refund the full remaining balance.",
    reasonLabel: "Reason (optional)",
    reasonPlaceholder: "e.g. customer request, duplicate charge",
    submitButton: "Issue refund",
    cancel: "Cancel",
  },
};
